import { jsx, css } from '@emotion/react';

import Cta from './oc-cta';
import Icon from './oc-icon';
import Link from './oc-link';
import { If } from '../Utilities';
import { connectLocation } from '../location/LocationConnectors';

const Contact = connectLocation(({ details, form = 'ask-an-expert', t, locale }) => {
  // PROPS

  // details    -   The contact object provided by MDMS
  // form       -   The form URL to use in contact button link

  const name = `${details.first_name} ${details.last_name}`;
  const headshot = 'headshot' in details && 'url' in details.headshot ? details.headshot.url : false;

  return (
    <div css={[styles.card, locale.code != 'fr-CA' ? styles.cardThreeColumns : null]}>
      <div css={styles.info}>
        <If condition={headshot}>
          <img css={styles.headshot} src={headshot} />
        </If>

        <div css={styles.content}>
          <span css={styles.name}>
            {name}
            <If condition={details.linkedin_url}>
              <Link
                href={details.linkedin_url}
                analytics={{
                  track: 'linkedin',
                  professional: 'Owens Corning Composites Professional',
                  'professional-name': name,
                }}
                aria-label="Owens Corning Composites Professional LinkedIn"
              >
                <Icon type="linkedin" />
              </Link>
            </If>
          </span>

          <p css={styles.title}>{details.title || details.division || details.application}</p>

          <Cta
            color="white"
            href={`/${form}?id=${details.id}`}
            analytics={{
              track: 'find-a-professional',
              professional: 'Owens Corning Composites Professional',
              'professional-name': name,
            }}
          >
            {t('components.contacts.cta')} {details.first_name}
          </Cta>
        </div>
      </div>
    </div>
  );
});

export const Contacts = ({ list, form }) => (
  // PROPS

  // list     -   Array of contact objects provided by MDMS
  // form     -   The form URL to use in contact button link

  <div css={styles.container}>
    {list.map((contact, index) => (
      <Contact details={contact} form={form} key={index} />
    ))}
  </div>
);

const styles = {
  container: css`
    display: block;
    margin: 15px 0;

    @media (min-width: 768px) {
      flex-wrap: wrap;
      display: flex;
    }

    @media (min-width: 1200px) {
      margin: 30px 0;
    }
  `,
  card: css`
    display: inline-block;
    margin-bottom: 15px;
    width: 100%;

    @media (min-width: 768px) and (max-width: 1199px) {
      flex-basis: 50%;

      &:nth-of-type(2n-1) > div {
        margin-left: 0px;
        margin-right: 15px;
      }
      &:nth-of-type(2n) > div {
        margin-left: 15px;
        margin-right: 0px;
      }
    }
  `,
  cardThreeColumns: css`
    @media (min-width: 1200px) {
      flex-basis: 33.3333%;
      margin-bottom: 30px;

      & > div {
        margin: 0 10px;
      }

      &:nth-of-type(3n-2) > div {
        margin-left: 0px;
        margin-right: 20px;
      }
      &:nth-of-type(3n) > div {
        margin-left: 20px;
        margin-right: 0px;
      }
    }
  `,
  info: css`
    border-top: 2px solid black;
    padding: 15px 0 30px 0;
  `,
  content: css`
    padding-left: 90px;

    @media (min-width: 1200px) {
      padding-left: 115px;
    }
  `,
  headshot: css`
    width: 75px;
    margin: 0 15px 0 0;
    float: left;

    @media (min-width: 1200px) {
      width: 100px;
    }
  `,
  name: css`
    font-size: 18px;
    font-weight: 700;
    position: relative;
    display: block;
    margin-bottom: 5px;

    @media (min-width: 1200px) {
      font-size: 21px;
    }

    a {
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 18px;
      color: black;
    }
  `,
  title: css`
    margin-top: 0;
    margin-bottom: 10px;
    font-size: 14px;

    @media (min-width: 1200px) {
      font-size: 16px;
    }
  `,
};
